define('lq/events/actions/downloadFileCommand',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq'
], function (_, EventAction, lq) {
    'use strict';

    function DownloadFileCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(DownloadFileCommand, EventAction);

    DownloadFileCommand.typeName = 'DownloadFileCommand';

    DownloadFileCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    DownloadFileCommand.prototype.execute = function (continuation) {
        var queryString = {
            actionId: this.piping.actionId,
            commandId: this.eventData.command,
            parameters: JSON.stringify(this.piping.parameters.getNonSystemParameters())
        };
        window.location = this.piping.url.prepare(lq.getTenantUrl('Export/File'), queryString);
        
        continuation();
    };

    return DownloadFileCommand;
});
